angular.
module("dx.webapp.lists").
controller("DxRubriclistController", function RubriclistController(
	dxUserSettings,
	dxAngularConstantHelper,
	dxSession,

	dxLocalize
) {
	"use strict";

	this.dxLocalize = dxLocalize;

	var self = this;

	var DX_USER_SETTINGS_TYPE = dxAngularConstantHelper.DX_USER_SETTINGS_TYPE;
	var userId = dxSession.getUser().id;

	self.searchSortState = {
		searchString: "",
		sortString: dxUserSettings.getSetting(userId, DX_USER_SETTINGS_TYPE.RUBRICS_SORT),
	};

	self.sortOptions = [
		{value: "-updated", name: "SearchSortFilter.DateModified"},
		{value: "title", name: "SearchSortFilter.Title"},
		{value: "description", name: "SearchSortFilter.Description"},
	];

	var searchableProperties = ["title", "description"];

	self.searchExpression = function searchExpression(rubric) {
		if (!self.searchSortState.searchString) {
			return true;
		}

		var match = false;

		searchableProperties.forEach(function foreach(property) {
			if (match) {
				return;
			}

			match = rubric[property].toString().toLowerCase().indexOf(self.searchSortState.searchString.toLowerCase()) !== -1;
		});

		return match;
	};

	self.changeSortingOption = function changeSortingOption() {
		dxUserSettings.setSetting(userId, DX_USER_SETTINGS_TYPE.RUBRICS_SORT, self.searchSortState.sortString);
	};
});
